import { render, staticRenderFns } from "./SocialFeedPostDetailModal.vue?vue&type=template&id=4e47763b&scoped=true"
import script from "./SocialFeedPostDetailModal.vue?vue&type=script&lang=ts"
export * from "./SocialFeedPostDetailModal.vue?vue&type=script&lang=ts"
import style0 from "./SocialFeedPostDetailModal.vue?vue&type=style&index=0&id=4e47763b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e47763b",
  null
  
)

export default component.exports